import {
  fetchPerformanceMetricsOptions,
  STATIC_FALLBACK_CATALOG,
} from '@/features/evaluation/api/performanceMetricsApi';

/**
 * When false, the Configure deployment modal uses {@link DEPLOYMENT_INFRA_CATALOG}
 * instead of the DB-backed catalog from `/performance-metrics/options`.
 * Set to true to restore model-specific infra options from the database.
 */
export const USE_DB_DEPLOYMENT_INFRA_CATALOG = false;

/**
 * Hardcoded AWS infrastructure options for the Configure deployment modal.
 * GPU is listed before CPU so `pickFirstSelection()` defaults to GPU / T4 / g4dn.xlarge.
 *
 *   { [cloud]: { [hardware]: { [accelerator|'null']: InstanceTypeOption[] } } }
 */
export const DEPLOYMENT_INFRA_CATALOG = Object.freeze({
  AWS: {
    GPU: {
      T4: [{ value: 'g4dn.xlarge', label: 'g4dn.xlarge', maxInstances: 7 }],
      A10G: [{ value: 'g5.xlarge', label: 'g5.xlarge', maxInstances: 7 }],
      L40S: [{ value: 'g6e.xlarge', label: 'g6e.xlarge', maxInstances: 12 }],
      A100: [{ value: 'p4d.24xlarge', label: 'p4d.24xlarge', maxInstances: 20 }],
    },
    CPU: {
      null: [{ value: 'm6i.2xlarge', label: 'm6i.2xlarge', maxInstances: 4 }],
    },
  },
});

/**
 * Resolve the infrastructure catalog for the Configure deployment modal.
 *
 * @param {{ baseModelName?: string|null }} params
 * @returns {Promise<Object>}
 */
export async function resolveDeploymentInfraCatalog({ baseModelName } = {}) {
  if (!USE_DB_DEPLOYMENT_INFRA_CATALOG) {
    return DEPLOYMENT_INFRA_CATALOG;
  }

  try {
    const resp = await fetchPerformanceMetricsOptions({ baseModelName });
    if (resp?.machineCatalog && Object.keys(resp.machineCatalog).length) {
      return resp.machineCatalog;
    }
  } catch {
    // Fall through to static fallback below.
  }
  return STATIC_FALLBACK_CATALOG;
}
